import React from "react";

function TermsAndConditions() {
  return (
    <div className="container mx-auto p-8 bg-gray-50 rounded-lg shadow-lg">
      <h1 className="text-4xl font-bold mb-6 text-center text-blue-600">Terms and Conditions</h1>
      <p className="text-sm text-gray-500 mb-6 text-center">Last Updated: 28 October 2024</p>

      <h2 className="text-3xl font-semibold mt-8 text-blue-500">1. Introduction</h2>
      <p className="text-lg mt-4 text-gray-700">
        Welcome to OPTX Insights, a service by OPTX Co., Ltd. ("we," "us," or "our"). OPTX Insights provides users ("you" or "user") with social media insights by integrating with various social media APIs, including but not limited to Facebook, TikTok, and YouTube. By accessing or using our website, optxinsights.com, you agree to comply with these Terms and Conditions. Please read these terms carefully.
      </p>

      <h2 className="text-3xl font-semibold mt-8 text-blue-500">2. Scope of Service</h2>
      <p className="text-lg mt-4 text-gray-700">
        OPTX Insights allows users to retrieve social media insights, including competitor data, using APIs provided by social media platforms. These insights include, but are not limited to, metrics such as engagement rates, follower counts, and public performance data. Data retrieved is used solely for the purpose of providing competitive analysis insights.
      </p>

      <h2 className="text-3xl font-semibold mt-8 text-blue-500">3. Data Collection and Usage</h2>
      <p className="text-lg mt-4 text-gray-700">
        We collect publicly available social media data through authorized access to social media APIs, including Facebook’s Graph API. Data is accessed with the user’s permission, and only data that is expressly authorized for retrieval will be collected. The data will not be used for any purpose other than providing insights, analytics, and reports as specified in the Scope of Service.
      </p>

      <h2 className="text-3xl font-semibold mt-8 text-blue-500">4. Compliance with Facebook and Other APIs</h2>
      <p className="text-lg mt-4 text-gray-700">
        OPTX Insights adheres to Facebook’s API Terms of Service and other platforms' terms governing data access. This includes, but is not limited to:
      </p>
      <ul className="list-disc pl-8 text-lg text-gray-700 mt-2">
        <li>Limiting data access to publicly available data or data where express permissions have been granted.</li>
        <li>Adhering to data privacy policies and prohibiting unauthorized data sharing or usage.</li>
        <li>Providing transparency in how data is collected, processed, and displayed on our platform.</li>
      </ul>

      <h2 className="text-3xl font-semibold mt-8 text-blue-500">5. User Responsibilities</h2>
      <p className="text-lg mt-4 text-gray-700">
        By using OPTX Insights, you agree to:
      </p>
      <ul className="list-disc pl-8 text-lg text-gray-700 mt-2">
        <li>Only access and use data in compliance with all applicable laws and third-party policies, including those provided by Facebook and other social media platforms.</li>
        <li>Not misuse data or engage in unauthorized activities that may infringe upon others' intellectual property rights or privacy.</li>
      </ul>

      <h2 className="text-3xl font-semibold mt-8 text-blue-500">6. Privacy</h2>
      <p className="text-lg mt-4 text-gray-700">
        Our Privacy Policy, which describes how we handle your personal information and the data retrieved through social media APIs, is an integral part of these Terms and Conditions. By using our services, you consent to the terms outlined in our Privacy Policy.
      </p>

      <h2 className="text-3xl font-semibold mt-8 text-blue-500">7. Intellectual Property</h2>
      <p className="text-lg mt-4 text-gray-700">
        All content, features, and functionalities on optxinsights.com are the exclusive property of OPTX Co., Ltd., except for third-party content and data retrieved through APIs, which are the property of their respective owners and used under license or authorization.
      </p>

      <h2 className="text-3xl font-semibold mt-8 text-blue-500">8. Limitation of Liability</h2>
      <p className="text-lg mt-4 text-gray-700">
        OPTX Co., Ltd. will not be liable for any loss or damage arising from the use of data obtained through social media APIs. Data accuracy and completeness are subject to the data provided by third-party platforms and are beyond our control.
      </p>

      <h2 className="text-3xl font-semibold mt-8 text-blue-500">9. Modifications</h2>
      <p className="text-lg mt-4 text-gray-700">
        We reserve the right to modify these Terms and Conditions at any time. Any changes will be updated on this page, and continued use of our services constitutes acceptance of any modified terms.
      </p>

      <h2 className="text-3xl font-semibold mt-8 text-blue-500">10. Contact Us</h2>
      <p className="text-lg mt-4 text-gray-700">
        For questions or concerns about these Terms and Conditions, please contact us at chawachai@optx.co.th
      </p>
    </div>
  );
}

export default TermsAndConditions;

